export default __webpack_public_path__ + "static/media/Quickadd.4612f611.svg";